import { IRetailer } from '@faire/web-api--source/indigofair/data/IRetailer';
import { SettingConst } from '@faire/web-api--source/types';

/**
 * Configuration for options of opening year question in signup flow
 */
export const OWF_OPENING_YEAR_OPTIONS =
  'OWF_OPENING_YEAR_OPTIONS' as SettingConst<
    'OWF_OPENING_YEAR_OPTIONS',
    Array<keyof typeof IRetailer.ReportedCreationTime>,
    'RETAILER' | 'VISITOR_WEB'
  >;
